import { FC } from 'react'

export type IStarInput = {
  name: string
  value: number
  onChange: (name: string, star: number) => void
}
export const StarInput: FC<IStarInput> = ({ name, value, onChange }) => {
  const stars = [1, 2, 3, 4, 5]

  return (
    <div className='d-flex gap-2'>
      {stars.map((star) => (
        <span
          key={star}
          onClick={() => onChange(name, star)}
          style={{
            cursor: 'pointer',
            fontSize: '28px',
            color: value >= star ? '#f4c430' : '#ccc',
          }}
        >
          ★
        </span>
      ))}
    </div>
  )
}
